// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class SetString {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetString {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetString(bb: flatbuffers.ByteBuffer, obj?: SetString): SetString {
    return (obj || new SetString()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetString(bb: flatbuffers.ByteBuffer, obj?: SetString): SetString {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetString()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): string | null
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  value(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  static startSetString(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, valueOffset, 0)
  }

  static endSetString(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetString(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetString.startSetString(builder)
    SetString.addValue(builder, valueOffset)
    return SetString.endSetString(builder)
  }
}
